/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fluffy_Day_Turtle_EarnInputs */

const fr_fluffy_day_turtle_earn = /** @type {(inputs: Fluffy_Day_Turtle_EarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un programme`)
};

/**

* @param {Fluffy_Day_Turtle_EarnInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fluffy_day_turtle_earn = /** @type {((inputs?: Fluffy_Day_Turtle_EarnInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fluffy_Day_Turtle_EarnInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fluffy_day_turtle_earn(inputs)
});